/* eslint-disable */
export default {
  unknown: 'Desconhecido',
  anonymous: 'Anônimo',
  activeCall: 'Chamada ativa',
} as const;

// @key: @#@"unknown"@#@ @source: @#@"Unknown"@#@
// @key: @#@"anonymous"@#@ @source: @#@"Anonymous"@#@
// @key: @#@"activeCall"@#@ @source: @#@"Active Call"@#@
